import { call, delay, put } from 'redux-saga/effects';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import { loadHostStatusesListBegin, loadHostStatusesListFailed, loadHostStatusesListSuccessful } from '../actions';

export default function* loadHostStatusesList(action) {
  try {
    const {
      payload: {
        filter,
      } = {},
    } = action;
    const url = `${BACKEND_URL}/host-statuses`;
    const pool = {};
    filter.type = 1;
    if (filter && Object.keys(filter).length) {
      pool.filter = filter;
    }
    yield delay(LOADING_DELAY);
    yield put(loadHostStatusesListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      if (data && data.result && data.result.length) {
        data.meta.total = data.result.length;
      }
      yield put(loadHostStatusesListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadHostStatusesListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadHostStatusesListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
